import { Typography } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { COLOR, MEDIA_QUERIES_BREAKPOINTS, PX_TO_REM } from '@/globalStyles';
import { getPrivacyPolicyLink, getTermsOfUseLink } from '@/pages/Routing/routesAndLinks';
import { APP_RELEASE_VERSION } from '@/utils/constants/common';

interface IStandardDesktopFooterProps {
    className?: string;
}
const StandardDesktopFooter = ({ className }: IStandardDesktopFooterProps) => {
    const { t, i18n } = useTranslation();
    return (
        <div className={className}>
            <LoveText variant="created_by">
                {t('moreView_footer_createdBy')} {t('commonString_applicationVersion_title')}: {APP_RELEASE_VERSION}
            </LoveText>
            <LinksWrapper>
                <a target="_blank" href={getTermsOfUseLink(i18n.language)} rel="noreferrer">
                    <StyledText variant="created_by">{t('legalIssues_footer_termsAndConditions_link')}</StyledText>
                </a>
                <a target="_blank" href={getPrivacyPolicyLink(i18n.language)} rel="noreferrer">
                    <StyledText variant="created_by">{t('legalIssues_footer_privacyPolicy_link')}</StyledText>
                </a>
            </LinksWrapper>
        </div>
    );
};

const Memoized = memo(StandardDesktopFooter);
const Styled = styled(Memoized)`
    padding: 0 ${PX_TO_REM[20]} ${PX_TO_REM[10]};
    display: flex;
    justify-content: space-between;

    @media screen and (width < ${MEDIA_QUERIES_BREAKPOINTS.tablet}px) {
        flex-direction: column;
    }
`;

const LoveText = styled(Typography)`
    color: ${COLOR.darkGray};
    @media screen and (width < ${MEDIA_QUERIES_BREAKPOINTS.tablet}px) {
        padding-bottom: ${PX_TO_REM[10]};
        text-align: center;
    }
`;

const StyledText = styled(Typography)`
    color: ${COLOR.darkGray};
    text-align: center;
`;

const LinksWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    @media screen and (width < ${MEDIA_QUERIES_BREAKPOINTS.tablet}px) {
        justify-content: center;
    }
    a:last-of-type {
        margin-left: 1rem;
    }
`;

export default Styled;
